module.exports = __webpack_public_path__ + "img/luzhangzi1.1fc83923.png";